(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tb-ui-react/dashed-frame/assets/dashed-frame.js') >= 0) return;  svs.modules.push('/components/tb-ui-react/dashed-frame/assets/dashed-frame.js');
'use strict';

const DashedFrame = _ref => {
  let children = _ref.children,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className;
  return React.createElement("div", {
    className: "align-center padding-2 u-border-style-dashed u-border-radius-12 ".concat(className)
  }, children);
};
svs.tb_ui_react.dashed_frame.DashedFrame = DashedFrame;

 })(window);